<div class="badge" (click)="onOpenDialog()">
	<span>{{badgeData}}</span>
</div>


